import { client } from '../client';
import { CasePayload } from './createNewCase';
import { ICase } from './types/ICase';

export const editCaseById = async (case_id: number, payload: CasePayload): Promise<ICase> => {
  const { data } = await client.patch(`/cases/${case_id}`, payload);

  return data;
};
